import React from "react";
import FilterList from "../../../components/user/outProcess/outFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const OutListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

OutListPage.propTypes = {};

export default OutListPage;
